import { render, staticRenderFns } from "./twoEnIndex.vue?vue&type=template&id=ac3132a2&scoped=true&"
import script from "./twoEnIndex.vue?vue&type=script&lang=js&"
export * from "./twoEnIndex.vue?vue&type=script&lang=js&"
import style0 from "./twoEnIndex.vue?vue&type=style&index=0&id=ac3132a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3132a2",
  null
  
)

export default component.exports